import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { ITimelineStyles } from '../Timeline/types';

const defaultStyles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-evenly',
        marginLeft: 10,
        marginRight: 10
    },
    touchable: {
        flex: 1,
        position: 'relative',
        paddingHorizontal: 5,
        paddingVertical: 10,
        // backgroundColor: 'red',
        height: 20
    },
    holder: {
        flex: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: 0,
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative'
    },
    progressIndicator: {
        position: 'relative',
        width: 0.2,
        height: 3,
        backgroundColor: Theme.primaryActiveColor,
        borderRadius: 0
    },
    preLoadedIndicator: {
        position: 'relative',
        width: 0.2,
        height: 3,
        backgroundColor: Theme.primaryTextColor,
        borderRadius: 0
    },
    preLoadedIndicatorContainer: {
        flex: 1,
        position: 'relative'
    },
    liveDuration: {
        color: Theme.primaryActiveColor
    },
    duration: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 21
    },
    liveIndicator: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 24,
        marginHorizontal: 20
    },
    seeker: {
        width: 10,
        height: 10,
        backgroundColor: '#FFFFFF',
        borderRadius: 3,
        position: 'absolute'
    },
    draggedSeeker: {
        width: 15,
        height: 15
    },
    pressRetentionOffset: {
        top: 1000,
        left: 1000,
        bottom: 1000,
        right: 1000
    },
    timelineStyles: {},
    timelineStyle: {
        height: 3,
        backgroundColor: 'rgba(255,255,255,0.3)'
    },
    currentTime: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        marginLeft: 10,
        fontSize: 21
    }
});

export const timelineStyles: ITimelineStyles = {
    container: {
        flex: 1,
        marginLeft: 15,
        marginRight: 15
    },
    progress: {
        backgroundColor: Theme.primaryActiveColor
    },
    buffered: {
        backgroundColor: Theme.primaryTextColor
    },
    dvrWindow: {
        backgroundColor: Theme.primaryTextColor
    },
    progressLive: {
        backgroundColor: Theme.primaryActiveColor
    },
    progressTime: {
        container: {
        },
        backgroundContainer: {
            fontFamily: Theme.regularFont,
            // padding: 3,
            bottom: 35,
            height: 25,
        },
        time: {
            fontSize: 15
        }
    },
    progressBar: {
        backgroundColor: Theme.primaryActiveColor
    }
};

export default defaultStyles;
